﻿import { ajax } from 'rxjs/ajax';
import { map, catchError, of, Observable } from 'rxjs';

function getTimezoneOffset():string {
    let date = new Date();
    const offset = date.getTimezoneOffset();
    return String(offset);
}

function fixUrl(url: string): string {
    const baseAddress = (<HTMLInputElement>document.querySelector('#GLOBAL_API_BASEADDRESS')).value;
    if (url.startsWith('/') == false) {
        url = '/' + url;
    }
    return baseAddress + url;
}

export function getJson<T>(url): Observable<T> {
    return ajax<T>({
        url: fixUrl(url),
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'timezone-offset': getTimezoneOffset()
        }
    }).pipe(
        map(response => response.response),
        catchError(error => {
            console.log('get Json error: ', error);
            return of(error);
        })
    );
}

export function postJson<T>(url: string, body: any): Observable<T> {
    return ajax<T>({
        url: fixUrl(url),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'timezone-offset': getTimezoneOffset()
        },
        body: body
    }).pipe(
        map(response => response.response),
        catchError(error => {
            console.log('error: ', error);
            return of(error);
        })
    );
}